import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Divider from '@mui/material/Divider'
import { useTranslation } from 'react-i18next'
import logo from '../images/logo_white.png'
import LanguageToggle from './LanguageToggle'

export default function Nav(props) {
    const { auth, setAuth } = props
    const { perms, username } = auth
    const [anchorElNav, setAnchorElNav] = useState(null)
    const [anchorElUser, setAnchorElUser] = useState(null)
    const [anchorElAcc, setAnchorElAcc] = useState(null)
    const [anchorElAdmin, setAnchorElAdmin] = useState(null)
    const [anchorElRoot, setAnchorElRoot] = useState(null)

    // Set available fields based on perms
    const INVC = perms.INVC ? ['inventory_check'] : null
    // Reviewer-only. Not INVC (Sales inherits it) and not ROOT (Admin lacks it).
    const INVCR = perms.INVCR ? ['inventory_check_report'] : null
    const COMS = perms.COMS
        ? [
            { page: 'confirm_sales', label: 'nav.confirmSales' },
            { page: 'pay_commissions', label: 'nav.payCommissions' }
          ]
        : null
    const VEND = perms.VEND ? [{ page: 'vendors', label: 'nav.vendors' }] : null
    const CAP = perms.ROOT ? [{ page: 'capital', label: 'nav.capital' }] : null
    const ROOT = perms.ROOT ? ['users'] : null
    const PHOTOR = perms.PHOTOR ? ['photo_review'] : null
    const CAL = perms.CAL_VIEW ? [{ page: 'calendar', label: 'nav.calendar' }] : null
    const CALM = perms.CAL_MANAGE ? [{ page: 'calendar_attention', label: 'nav.calendarAttention' }] : null
    const FINANCE = [...(CAL || []), ...(CALM || []), ...(CAP || [])]
    const navigate = useNavigate()
    const { t } = useTranslation()

    function handleClickPage(page) {
        if (anchorElNav) handleCloseNavMenu()
        if (anchorElAcc) handleCloseAccMenu()
        if (anchorElAdmin) handleCloseAdminMenu()
        if (anchorElRoot) handleCloseRootMenu()
        navigate(`/${page.replace('_', '-')}`)
    }

    function handleOpenNavMenu(event) {
        setAnchorElNav(event.currentTarget)
    }

    function handleOpenUserMenu(event) {
        setAnchorElUser(event.currentTarget)
    }

    // Accounting Controls
    // function handleOpenAccMenu(event) {
    //     setAnchorElAcc(event.currentTarget)
    // }

    // function handleOpenAdminMenu(event) {
    //     setAnchorElAdmin(event.currentTarget)
    // }

    function handleCloseNavMenu() {
        setAnchorElNav(null)
    }

    function handleCloseUserMenu() {
        setAnchorElUser(null)
    }

    function handleCloseAccMenu() {
        setAnchorElAcc(null)
    }

    function handleCloseAdminMenu() {
        setAnchorElAdmin(null)
    }

    function handleCloseRootMenu() {
        setAnchorElRoot(null)
    }

    function logout() {
        const url = 'https://shqb-connector.delsonfoundation.com/dashboard/logout'

        fetch(url, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        })

        setAuth(prevAuth => ({ ...prevAuth, isLoading: false, isLogged: false }))
    }

    return (
        <div className='navbar'>
            <AppBar position='static' sx={{ userSelect: 'none' }}>
                <Container maxWidth='xl'>
                    <Toolbar disableGutters>
                        {/* ===================== SIDE NAV MENU ===================== */}
                        <Paper
                            elevation={0}
                            sx={{
                                display: { xs: 'flex' },
                                bgcolor: 'transparent',
                                flexGrow: 1,
                                justifyContent: 'center'
                            }}
                        >
                            <img
                                className='logo'
                                onClick={() => navigate('/')}
                                src={logo}
                                alt='Delson Jewelry'
                            />
                        </Paper>

                        <Box sx={{ flexGrow: 1, display: 'flex', position: 'absolute' }}>
                            <IconButton
                                size='large'
                                aria-label='menu'
                                aria-controls='menu-appbar'
                                aria-haspopup='true'
                                onClick={handleOpenNavMenu}
                                color='inherit'
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id='menu-appbar'
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left'
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                // sx={{
                                //     display: { xs: 'block' }
                                // }}
                            >
                                <MenuItem key='products' onClick={() => handleClickPage('products')}>
                                    {t('nav.products')}
                                </MenuItem>
                                <MenuItem key='find_piece' onClick={() => handleClickPage('find-piece')}>
                                    {t('nav.findPiece')}
                                </MenuItem>
                                <Divider />
                                <MenuItem key='photo_upload' onClick={() => handleClickPage('photo_upload')}>
                                    {t('nav.photoUpload')}
                                </MenuItem>
                                {PHOTOR && (
                                    <MenuItem key='photo_review' onClick={() => handleClickPage(PHOTOR[0])}>
                                        {t('nav.photoReview')}
                                    </MenuItem>
                                )}
                                <Divider />
                                {/* {ACC && <Divider />}
                                {ACC &&
                                    ACC.map(page => (
                                        <MenuItem key={page} onClick={() => handleClickPage(page)}>
                                            {t('nav.accounting')}
                                        </MenuItem>
                                    ))} */}
                                {INVC && (
                                    <MenuItem onClick={() => handleClickPage(INVC[0])}>
                                        {t('nav.inventoryCheck')}
                                    </MenuItem>
                                )}
                                {/* The path is passed already finished: handleClickPage's
                                    replace() swaps only the FIRST underscore, so passing
                                    INVCR[0] would navigate to '/inventory-check_report'. */}
                                {INVCR && (
                                    <MenuItem onClick={() => handleClickPage('inventory-check/report')}>
                                        {t('nav.inventoryCheckReport')}
                                    </MenuItem>
                                )}
                                {COMS && <Divider />}
                                {COMS && COMS.map(({ page, label }) => (
                                    <MenuItem key={page} onClick={() => handleClickPage(page)}>
                                        {t(label)}
                                    </MenuItem>
                                ))}
                                {VEND && <Divider />}
                                {VEND && VEND.map(({ page, label }) => (
                                    <MenuItem key={page} onClick={() => handleClickPage(page)}>
                                        {t(label)}
                                    </MenuItem>
                                ))}
                                {FINANCE.length > 0 && <Divider />}
                                {FINANCE.map(({ page, label }) => (
                                    <MenuItem key={page} onClick={() => handleClickPage(page)}>
                                        {t(label)}
                                    </MenuItem>
                                ))}
                                {ROOT && <Divider />}
                                {ROOT && (
                                    <MenuItem onClick={() => handleClickPage(ROOT[0])}>
                                        {t('nav.users')}
                                    </MenuItem>
                                )}
                            </Menu>
                        </Box>

                        <Box sx={{ flexGrow: 0, position: 'absolute', right: 0 }}>
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar alt={username?.toUpperCase()} src='/static/images/avatar/2.jpg' />
                            </IconButton>
                            <Menu
                                sx={{ mt: '45px' }}
                                id='menu-appbar'
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <LanguageToggle
                                    username={username}
                                    onSelect={handleCloseUserMenu}
                                />
                                <Divider />
                                <MenuItem onClick={() => logout()}>
                                    <Typography textAlign='center'>{t('nav.logout')}</Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    )
}
